<template>
  <v-avatar color="primary" size="20" class="mb-2">
    <v-progress-circular v-if="loading" :size="18" :width="2" indeterminate
                         color="white">

    </v-progress-circular>
    <div v-else>
      {{value}}
    </div>
  </v-avatar>
</template>
<script>
  export default {
    name: "AvatarLoader",
    props: {
      loading: {},
      value: {}
    }
  }
</script>